import YouTube from './YouTube';
import compose from 'recompose/compose';
import withMediaQueries from '../../hocs/withMediaQueries';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import { trackVideoState } from '../../../analytics/category/video';

const playerState = {
  0: 'Finished',
  1: 'Play',
  2: 'Pause'
};

const enhance = compose(
  withMediaQueries,
  withState('isPlaying', 'setPlaying', false),
  withState('isTouched', 'setTouched', false),
  withHandlers({
    handleClick: props => () => {
      if (!props.isDisabled) {
        props.setPlaying(true);
        props.setTouched(true);
        props.setIsCarouselMediaPlaying && props.setIsCarouselMediaPlaying(true);
      }
    },
    handleReady: props => event => {
      if (props.muteOnReady) {
        event.target.mute();
      }
      if (props.isPlaying) {
        event.target.playVideo();
      } else {
        event.target.pauseVideo();
      }
    },
    handleEnd: props => () => props.setPlaying(false),
    handleStateChange: props => event => {
      const state = playerState[event.data];
      if (state) {
        trackVideoState(state);
      }
      if (props.setIsCarouselMediaPlaying) {
        if (event.data === 0 || event.data === 2) {
          props.setIsCarouselMediaPlaying(false);
        } else {
          props.setIsCarouselMediaPlaying(true);
        }
      }
    }
  })
);

export default enhance(YouTube);



// WEBPACK FOOTER //
// ./src/client/js/view/components/YouTube/index.js